import { ReactSimpleComponentProps } from '@/custom-types';
import { useMemo, useState } from 'react';
import { AddIncidentExpenseFormModalContext, AddIncidentExpenseFormModalContextProps } from './AddIncidentExpenseFormModalContext';

export const AddIncidentExpenseFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [incidentId, setIncidentId] = useState<string | null>(null);

  const actions = useMemo<Omit<AddIncidentExpenseFormModalContextProps, 'incidentId' | 'isOpen'>>(() => ({
    openModal: (id: string) => {
      setIncidentId(id);
      setIsOpen(true);
    },

    closeModal: () => {
      setIsOpen(false);
      setIncidentId(null);
    },
  }), []);

  return (
    <AddIncidentExpenseFormModalContext.Provider value={{ ...actions, isOpen, incidentId }}>
      {children}
    </AddIncidentExpenseFormModalContext.Provider>
  );
};
